import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

export function requireAuthentication(Component) {
    class AuthenticatedComponent extends React.Component {

        componentWillMount () {
            this.checkAuth(this.props.authenticated);
        }

        componentWillReceiveProps (nextProps) {
            this.checkAuth(nextProps.authenticated);
        }

        checkAuth (isAuthenticated) {
            if (!isAuthenticated) {
                let redirectAfterLogin = this.props.location.pathname;
                this.props
                    .dispatch(push(`/login?next=${redirectAfterLogin}`));
            }
        }

        render () {
            return (
                this.props.authenticated && <Component {...this.props} />
            );
        }
    }

    const mapStateToProps = (state) => ({
        authenticated: state.auth.authenticated
    });


    return connect(mapStateToProps)(AuthenticatedComponent);
}


// WEBPACK FOOTER //
// ./src/containers/auth/require_auth.js